<!--title -->
<app-modal-title
  [title]="formPageConfig.title | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div mat-dialog-content class="dialog-content">
  <div class="alert alert-primary alert-style tw-w-[350px] tw-leading-normal">
    {{ formPageConfig.vocabs + "description" | translate }}
  </div>
  <div *ngIf="showPrivateNumbers" class="alert alert-danger tw-w-[350px] tw-leading-normal">
    {{ "messages.ifNumberIsNotServiceSmsWillNotBeSentToBlackList" | translate }}
  </div>

  <!-- form -->
  <form [formGroup]="form" autocomplete="off">
    <div class="row tw-w-[350px] m-0">
      <!-- key -->
      <div class="md:tw-w-full tw-px-0">
        <enum-select-search
          enumName="MainSettings"
          [label]="'common.key'"
          [control]="form?.get('key')"
          [removable]="!formPageConfig.isEditMode"
          [isDisabled]="formPageConfig.isEditMode"
          [value]="model.key"
          (valueChange)="onChangeKey($event)"
          (onError)="onClose()"
        >
        </enum-select-search>
      </div>
    </div>
    <div class="row tw-w-[350px] m-0">
      <!-- value -->
      <div
        class="md:tw-w-full tw-px-0"
        *ngIf="!showPrivateNumbers && !isShowNumberInput"
      >
        <form-textarea
          class="tw-w-full"
          label="common.value"
          [(value)]="model.value"
          [control]="form?.get('value')"
          [rows]="2"
        >
        </form-textarea>
      </div>

      <div
        *ngIf="isShowNumberInput || showPrivateNumbers"
        class="md:tw-w-full tw-px-0"
      >
        <!--number value-->
        <form-field
          *ngIf="isShowNumberInput"
          [value]="numberValue"
          (valueChange)="changeValue($event, 'number')"
          [hasCurrency]="true"
          type="tel"
          [hasNumberSeparator]="true"
          label="common.value"
          [control]="form?.get('value')"
        >
        </form-field>

        <!--private number-->
        <private-number-select-search
          *ngIf="showPrivateNumbers"
          [value]="numberId"
          [control]="form?.get('value')"
          (itemChange)="changeValue($event, 'privateNumber')"
          (onError)="onClose()"
        >
        </private-number-select-search>
      </div>
    </div>

    <!-- form btns-->
    <app-form-btns
      [loading]="loading"
      [form]="form"
      [isEdit]="formPageConfig.isEditMode"
      (onClose)="onClose()"
      (onSubmit)="onSubmit()"
    >
    </app-form-btns>
  </form>
</div>
